import React, { Component } from "react";
import json from "./database.json";
import formatJson from "./helpers/formatJson";
import Root from "./Root";

const normalized = formatJson(json);
export const AppContext = React.createContext();

class App extends Component {
  state = { ...normalized, actions: {} };

  render() {
    return (
      <AppContext.Provider value={{ store: this.state }}>
        <Root />
      </AppContext.Provider>
    );
  }
}

export default App;
